import React from 'react';
import R from 'ramda';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Breadcrumbs from '@cotyorg/ccx-molecules/Breadcrumbs';
import {
  Accordion,
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody,
} from '@cotyorg/ccx-molecules/Accordion';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';
import uuid from '@cotyorg/ccx-utils/js/helpers/uuid';
import StandardLayout from '../../templates/StandardLayout';
import PageDescription from '../../organisms/PageDescription/PageDescription';

const FaqComponent = ({ sectionHeadings, breadcrumb, accordionItems }) => (
  <StandardLayout>
    <div className="faq-introduction-section">
      <div className="grid-container">
        <div className="grid-x grid-padding-x">
          <div className="cell xsmall-16">
            <Breadcrumbs items={breadcrumb} />
          </div>
        </div>
      </div>
      <PageDescription
        level={2}
        heading={R.path(['introductionSection', 'heading'], sectionHeadings)}
        text={R.path(['introductionSection', 'subheading'], sectionHeadings)}
      />
    </div>

    <div className="faq-accordion-section">
      <div className="grid-container">
        <div className="grid-x grid-padding-x">
          <div className="cell xsmall-16 medium-12 medium-offset-2">
            <Accordion>
              {R.map(
                (item) => (
                  <AccordionItem key={uuid()}>
                    <AccordionItemTitle
                      buttonExtraClass="accordion__item-button"
                      minusIconSrc="/ccx-files/assets/chevron-up.svg"
                      plusIconSrc="/ccx-files/assets/chevron-down.svg"
                    >
                      {R.prop('title', item)}
                    </AccordionItemTitle>
                    <AccordionItemBody>
                      <Paragraph>{R.prop('description', item)}</Paragraph>
                    </AccordionItemBody>
                  </AccordionItem>
                ),
                accordionItems
              )}
            </Accordion>
          </div>
        </div>
      </div>
    </div>
  </StandardLayout>
);

FaqComponent.propTypes = {
  breadcrumb: PropTypes.arrayOf(PropTypes.object),
  sectionHeadings: PropTypes.objectOf(PropTypes.object),
  accordionItems: PropTypes.arrayOf(PropTypes.object),
};

const mapStateToProps = ({ content }) => ({
  breadcrumb: R.prop('breadcrumb', content),
  sectionHeadings: R.prop('sectionHeadings', content),
  accordionItems: R.prop('accordionItems', content),
});

export default connect(mapStateToProps)(FaqComponent);
